export type IExpandableItem<T> = T & {expand: boolean};
